import React from 'react';
import { Button } from 'react-bootstrap';
import './Button.css';
import styled from 'styled-components';

const ButtonStyle = styled.button`
  background: linear-gradient(135deg, #d90429 0%, #ef233c 100%);
  font-size: 16px;
  color: #ffffff;
  font-family: 'Outfit', sans-serif;
  font-weight: 700;
  letter-spacing: 0.3px;
  padding: 10px 28px;
  border: 0 !important;
  border-radius: 9999px;
  box-shadow: 0 4px 15px rgba(217, 4, 41, 0.3);
  transition: all 0.25s ease;
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'auto')};
  cursor: pointer;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 22px rgba(217, 4, 41, 0.45);
    background: linear-gradient(135deg, #b91c1c 0%, #d90429 100%);
    color: #ffffff;
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.65;
    cursor: not-allowed;
    transform: none;
  }

  @media (max-width: 768px) {
    font-size: 13px;
    padding: 8px 18px;
  }
`;

const CloseStyle = styled.button`
  font-size: 16px;
  border: 0 !important;
  color: #64748b;
  background: #f1f5f9;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  cursor: pointer;

  &:hover {
    background: #fee2e2;
    color: #ef233c;
    transform: scale(1.1);
  }
`;

const Buttons = ({ label, onClick, fullWidth, disabled }) => {
  return (
    <ButtonStyle onClick={onClick} fullWidth={fullWidth} disabled={disabled}>
      {label}
    </ButtonStyle>
  );
};

const Close = ({ label, onClick }) => {
  return (
    <CloseStyle onClick={onClick}>
      {label}
    </CloseStyle>
  );
};

const ButtonView = ({ label, onClick, className }) => {
  return (
    <div>
      <Button onClick={onClick} className={className}>
        {label}
      </Button>
    </div>
  );
};

export { Buttons, Close, ButtonView };